module.exports = __webpack_public_path__ + "img/companyIntro20.305f4a62.png";